import React from 'react';

const projekt = {
	'projekt.avaleht.pealkiri': 'We have many interesting projects in the works:',
	'projekt.leader.pealkiri': 'Leader project',
	'projekt.leader.kaart.kirjeldus': () => (
		<p>Installation of solar power to Varbla Holiday Village buildings</p>
	),
	'projekt.sadam.pealkiri': 'Varbla Holiday Village Harbor',
	'projekt.sadam.kaart.kirjeldus': <p>EstLat harbors</p>,
	'projekt.kook.pealkiri':
		'Acquisition of Varbla Holiday Village harbor kitchen appliances',
	'projekt.kook.kaart.kirjeldus': <></>,
	'projekt.kook.blokk1': (
		<>
			<h2>VARBLA PUHKEKÜLA SADAMAHOONE KÖÖGI-JA BAARISEADMETE SOETAMINE</h2>
			<p>Toetuse summa: 11 296.85</p>
			<p>
				Projekt elluviimine aitab kaasa ettevõtluse arendamisele ja
				mitmekesistamisele maapiirkonnas ning tõstab ettevõtte jätkusuutlikkust.
			</p>
			<p>
				Sadamahoone uus köök ja baar võimaldab teenindada mereturiste, samuti
				ümberkaudseid puhkajaid, luua uusi tooteid ja teenuseid ning väärindada
				kohalikku toidukultuuri.
			</p>
		</>
	),
};

export default projekt;
